import React from "react";
import PropTypes from "prop-types";
import { GroupHeader } from "./GroupHeader";
import { ItemGroupCheckbox } from "../BatchEdit/ItemGroupCheckbox";

export const Group = ({ date, total, children, projectId, className, items }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-ml-1">
        <ItemGroupCheckbox
          items={items}
          id={date}
        />
        <GroupHeader
          date={date}
          total={total}
          projectId={projectId}
          className="tw-mb-2"
        />
      </div>
      {children}
    </div>
  );
};

Group.propTypes = {
  date: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  items: PropTypes.array,
};

Group.defaultProps = {
  items: [],
};
